import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GoogleMapsLoaderService } from '../../../shared/services/google-maps-loader.service';
import { from, of } from 'rxjs';
import { catchError, switchMap, timeout } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

export const googleMapsResolver: ResolveFn<boolean> = (route, state) => {
  const googleMapsLoader = inject(GoogleMapsLoaderService);
  const authService = inject(AuthenticationService);

  // If already loaded, resolve immediately
  if (googleMapsLoader.isLoaded()) {
    return of(true);
  }

  // If not loaded, start loading and wait for it
  return authService.getGoogleAPIKey().pipe(
    switchMap((result) => {
      let key = result.data.propertyValue;
      // Convert Promise to Observable and wait for it to complete
      return from(googleMapsLoader.loadScript(key));
    }),
    timeout(10000),
    switchMap(() => of(true)),
    catchError((error) => {
      console.error('Failed to load Google Maps:', error);
      return of(false);
    })
  );
};
